import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { LineChart, CartesianGrid, Line, Tooltip, XAxis, YAxis, ResponsiveContainer, } from 'recharts';
import { color } from '../templates/Ui';
import { readableNumber, readableNumberParts } from '../../helpers/Numbers';
import { RANGE } from '../pages/Dashboard';
import { getAppTheme } from '../../services/appTheme';
const ChartWrapper = styled.div `
    display: none;

    @media only screen and (min-width: 992px) {
        position: relative;
        display: block;
        font-size: ${props => props.theme.chart?.fontSize};

        > div {
            width: calc(100% - 100px) !important;
            margin: 0 auto;
        }
    }

    .recharts-surface {
        overflow: visible;
    }
`;
const BalanceLabel = styled.label `
    position: absolute;
    top: 200px;
    left: -45px;
    transform: rotate(270deg);
    color: ${color.gray.base};
    font-size: 14px;
`;
const CasesLabel = styled.label `
    position: absolute;
    top: 200px;
    right: -45px;
    transform: rotate(90deg);
    color: ${color.gray.base};
    font-size: 14px;
`;
const ToggleDataButton = styled.button `
    display: block;
    margin: 45px 0 0 auto;
    position: relative;
    color: ${props => props.theme.secondary};
    font-weight: 600;
    background-color: transparent;
    border: none;
    outline: none;
    padding-bottom: 4px;
    transition: all 150ms ease-in-out;
    cursor: pointer;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${props => props.theme.secondary};
        transition: all 150ms ease-in-out;
    }

    &:hover,
    &:focus {
        color: ${props => props.theme.secondaryHover};

        &:after {
            background-color: ${props => props.theme.secondaryHover};
        }
    }
`;
const humanDate = (label) => {
    const date = new Date();
    const [dayOrMonth, monthOrYear] = label.split('-');
    if (parseInt(monthOrYear) > 1000) {
        date.setFullYear(parseInt(monthOrYear));
        date.setMonth(parseInt(dayOrMonth) - 1);
        return date.toLocaleDateString('nl-nl', {
            year: 'numeric',
            month: 'long',
            day: undefined,
        });
    }
    else {
        // Make sure it's a leap year
        date.setFullYear(2020);
        date.setMonth(parseInt(monthOrYear) - 1);
        date.setDate(parseInt(dayOrMonth));
        return date.toLocaleDateString('nl-nl', {
            year: undefined,
            month: 'long',
            day: 'numeric',
            weekday: 'long',
        });
    }
};
const DashboardChart = ({ statistics, range, setRange, }) => {
    const dateAxisString = (label) => {
        if (range === RANGE.YEAR) {
            return label.replace(/([0-9]+-)/, '');
        }
        return label;
    };
    const data = statistics?.open_dossiers?.amounts?.map((value, index) => ({
        name: dateAxisString(statistics.open_dossiers.dates[index]),
        cases: value,
        balance: statistics.outstanding_balance.amounts[index],
    }));
    return (_jsxs(ChartWrapper, { children: [data && (_jsxs(_Fragment, { children: [_jsx(BalanceLabel, { children: "Openstaand saldo" }), _jsx(CasesLabel, { children: "Aantal lopende zaken" }), _jsx(ResponsiveContainer, { height: 500, children: _jsxs(LineChart, { data: data, margin: {
                                left: 20,
                            }, children: [_jsx(CartesianGrid, { vertical: false, stroke: "#EDEEF0" }), _jsx(XAxis, { dataKey: "name", dy: 10 }), _jsx(YAxis, { width: 90, yAxisId: "left", tickFormatter: value => readableNumberParts(value).long, domain: ['auto', 'auto'] }), _jsx(YAxis, { width: 90, yAxisId: "right", orientation: "right", tickFormatter: value => readableNumberParts(value).long, domain: ['auto', 'auto'] }), _jsx(Tooltip, { labelFormatter: humanDate, formatter: (value) => readableNumber(value) }), _jsx(Line, { yAxisId: "left", type: "monotone", dataKey: "balance", name: "Openstaand saldo", stroke: getAppTheme().chart.colors[0], strokeWidth: 3, dot: false }), _jsx(Line, { yAxisId: "right", type: "monotone", dataKey: "cases", name: "Lopende zaken", stroke: getAppTheme().chart.colors[1], strokeWidth: 3, dot: false })] }) })] })), range === RANGE.YEAR && (_jsx(ToggleDataButton, { onClick: () => setRange(RANGE.MONTH), children: "Toon maandoverzicht" })), range === RANGE.MONTH && (_jsx(ToggleDataButton, { onClick: () => setRange(RANGE.YEAR), children: "Toon jaaroverzicht" }))] }));
};
export default DashboardChart;
